export default function getStyles(props, styles = {}) {
  return {
    wrapperDesktop: {
      display: 'flex',
      justifyContent: 'center'
    },
    imageOuter: {
      position: 'relative',
      width: '100%',
      height: '100%'
    },
    imageWrapper: {
      maxWidth: '100%',
      width: '100%'
    },
    imageDesktop: {
      maxHeight: '100%',
      maxWidth: '100%',
      flexShrink: 0
    },
    featuredContainer: {
      position: 'relative'
    },
    featuredThumbContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    ...styles
  };
}
